import { render, staticRenderFns } from "./NotesDisplay.vue?vue&type=template&id=9796c668"
import script from "./NotesDisplay.vue?vue&type=script&lang=js"
export * from "./NotesDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports